import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "yoyakuCountDisplay",
})
export class yoyakuCountDisplayPipe implements PipeTransform {
  transform(str1: string, str2: string): string {
    if (str2 == null) {
      return str1;
    } else {
      return str1+"/"+str2;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/yoyaku-count-display.pipe.ts